import {NotificationService} from "../../services/NotificationService";
import {EditPrinterModel} from "../../models/edit/EditPrinterModel";
import {Printer} from "../../entities/Printer";
import {EditBaseCtrl} from "./EditBaseCtrl";
import { StateService, StateParams } from "@uirouter/angularjs";

export class EditPrinterCtrl extends EditBaseCtrl<Printer> {
    public static $inject = ['$scope','$state','$stateParams','EditPrinterModel','NotificationService'];
    constructor($scope:any,
                stateService:StateService,
                stateParamsService:StateParams,
                public model:EditPrinterModel,
                public notifyService:NotificationService) {
        super($scope,stateService,stateParamsService, notifyService, model);
        $scope.vm = this;
    }
    pagingRoute():string{
        return "admin.printers";
    }
}
